<template>
	<div class="landing-page privacy">

		<!-- Top navbar -->
		<landing-page-navbar></landing-page-navbar>
		<div class="content-container">

			<div class="container" v-if="carrierDetails">
				<div class="row" v-if="carrierDetails.countryCodeAlpha2 != 'DE'">
                    <div class="col-md-10 col-lg-8">
                        <div class="privacy">
                            <div class="header">
                                <h1>{{$t('bp.privacyPolicy.Cap')}}</h1>
                                <template v-if="!carrierDetails.privacyLink">
                                    <p>This Application collects some Personal Data from its Users.</p>
                                    <p>Personal Data collected for the following purposes and using the following services:</p>
                                </template>
                            </div>

                            <div class="contain">
                                <div id="smallPolicy" v-if="carrierDetails.privacyLink">
                                    <hr>
                                    <a target="_blank" :href="carrierDetails.privacyLink">{{$t('bp.privacyPolicy.text')}}</a>
                                </div>

                                <div id="smallPolicy" v-if="!carrierDetails.privacyLink">
                                    <h3>Analytics</h3>
                                    <p><strong>Google Analytics and Google Adwords conversion tracking</strong>
                                        <br>Personal Data: Cookies and Usage data
                                    </p>

                                    <h3>Contacting The User</h3>
                                    <strong>Contact form</strong>
                                    <p>Personal Data: address, country, email address, first name, last name, phone number and ZIP/Postal code</p>

                                    <strong>Mailing List or Newsletter</strong>
                                    <p>Personal Data: email address</p>

                                    <strong>Phone contact</strong>
                                    <p>Personal Data: phone number</p>


                                    <h3>Displaying Content From External Platforms</h3>
                                    <strong>Google Maps widget</strong>
                                    <p>Personal Data: Cookies and Usage data</p>

                                    <div v-if="carrierDetails.usesKlarna">
                                        <h3>Heat Mapping</h3>
                                        <strong>SessionCam</strong>
                                        <p>Personal Data: Cookies and Usage data</p>
                                    </div>

                                    <h3>Contact information</h3>
                                    <strong>Data owner</strong>
                                    <p>{{ carrierDetails.address }}</p>

                                    <div v-if="carrierDetails.usesKlarna">
                                        <h3>Klarna Payments</h3>
                                        <p>
                                            In order to be able to offer you Klarna’s payment options, we will pass to Klarna certain aspects of your personal information, such as contact and order details, in order for Klarna to assess whether you qualify for their payment options and to tailor the payment options for you.
                                            General information on Klarna can be found <a href="https://www.klarna.com/uk/terms-and-conditions" target="_blank">here</a>. Your personal data is handled in accordance with applicable data protection law and in accordance with the information in Klarna’s privacy policy.
                                        </p>
                                    </div>
                                </div>

                                <div id="fullPolicy" style="display: none;">
                                    (Full Privacy Policy)

                                    <h3>Types of Data collected</h3>

                                    <p>Among the types of Personal Data that this Application collects, by itself or through third parties, there are: first name, last name, phone number, address, country, email address, Postal code, Cookies and Usage data.</p>

                                    <p>Other Personal Data collected may be described in other sections of this privacy policy or by dedicated explanation text contextually with the Data collection.
                                        The Personal Data may be freely provided by the User, or collected automatically when using this Application.</p>

                                    <p>Any use of Cookies - or of other tracking tools - by this Application or by the owners of third party services used by this Application, unless stated otherwise, serves to identify Users and remember their preferences, for the sole purpose of providing the service required by the User.
                                        Failure to provide certain Personal Data may make it impossible for this Application to provide its services.</p>

                                    <p>Users are responsible for any Personal Data of third parties obtained, published or shared through this Application and confirm that they have the third party's consent to provide the Data to the Owner.</p>


                                    <h3>Mode and place of processing the Data</h3>

                                    <p>Methods of processing
                                        The Data Controller processes the Data of Users in a proper manner and shall take appropriate security measures to prevent unauthorised access, disclosure, modification, or unauthorised destruction of the Data.</p>

                                    <p>The Data processing is carried out using computers and/or IT enabled tools, following organisational procedures and modes strictly related to the purposes indicated. In addition to the Data Controller, in some cases, the Data may be accessible to certain types of persons in charge, involved with the operation of the site (administration, sales, marketing, legal, system administration) or external parties (such as third party technical service providers, mail carriers, hosting providers, IT companies) appointed, if necessary, as Data Processors by the Owner. The updated list of these parties may be requested from the Data Controller at any time.</p>

                                    <strong>Place</strong>
                                    <p>The Data is processed at the Data Controller's operating offices and in any other places where the parties involved with the processing are located. For further information, please contact the Data Controller.</p>



                                    <strong>Retention time</strong>
                                    <p>The Data is kept for the time necessary to provide the service requested by the User, or stated by the purposes outlined in this document, and the User can always request that the Data Controller suspend or remove the data.</p>




                                    <h3>The use of the collected Data</h3>
                                    <p>The Data concerning the User is collected to allow the Owner to provide its services, as well as for the following purposes: Contacting the User, Analytics, Heat mapping, Displaying content from external platforms.</p>

                                    <p>The Personal Data used for each purpose is outlined in the specific sections of this document.</p>



                                    <h3>Detailed information on the processing of Personal Data</h3>
                                    <p>Personal Data is collected for the following purposes and using the following services:</p>


                                    <h3>Analytics:</h3>
                                    <p>The services contained in this section enable the Owner to monitor and analyse web traffic and can be used to keep track of User behaviour.</p>

                                    <strong>Google Analytics (Google Inc.)</strong>
                                    <p>Google Analytics is a web analysis service provided by Google Inc. (“Google”). Google utilises the Data collected to track and examine the use of this Application, to prepare reports on its activities and share them with other Google services.
                                        Google may use the Data collected to contextualise and personalise the ads of its own advertising network.</p>

                                    <p>Personal Data collected: Cookies and Usage data.</p>

                                    <p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)  – Opt Out (https://tools.google.com/dlpage/gaoptout?hl=en)</p>

                                    <strong>Google AdWords conversion tracking (Google Inc.)</strong>
                                    Google AdWords conversion tracking is an analytics service provided by Google Inc. that connects data from the Google AdWords advertising network with actions performed on this Application.

                                    <p>Personal Data collected: Cookies and Usage data.</p>

                                    <p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)</p>



                                    <h3>Contacting The User</h3>
                                    <strong>Contact form (This Application)</strong>
                                    <p>By filling in the contact form with their Data, the User authorises this Application to use these details to reply to requests for information, quotes or any other kind of request as indicated by the form’s header.</p>

                                    <p>Personal Data collected: address, country, email address, first name, last name, phone number and ZIP/Postal code.</p>

                                    <strong>Phone contact (This Application)</strong>
                                    <p>Users that provided their phone number might be contacted for commercial or promotional purposes related to this Application, as well as for fulfilling support requests.</p>

                                    <p>Personal Data collected: phone number.</p>

                                    <h3>Displaying content from external platforms</h3>
                                    <p>This type of services allows you to view content hosted on external platforms directly from the pages of this Application and interact with them.</p>
                                    <p>This type of service might still collect web traffic data for the pages where the service is installed, even when Users do not use it.</p>

                                    <strong>Google Maps widget (Google)</strong>
                                    <p>Google Maps is a maps visualisation service provided by Google Inc. that allows this Application to incorporate content of this kind on its pages.</p>

                                    <p>Personal Data collected: Usage data.</p>

                                    <p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)</p>

                                    <div v-if="carrierDetails.usesKlarna">
                                        <h3>Heat Mapping</h3>
                                        <p>Heat Mapping services are used to display the areas of a page where Users most frequently move the mouse or click. This shows where the points of interest are. These services make it possible to monitor and analyse web traffic and keep track of User behaviour.</p>

                                        <p>Crazy Egg (Crazy Egg, Inc.) is a Heat Mapping service provided by Crazy Egg, Inc.</p>

                                        <p>Personal Data collected: Cookies and Usage data.</p>

                                        <p>Place of processing: US - Privacy Policy (Crazy Egg Privacy Policy - https://www.crazyegg.com/privacy)</p>
                                    </div>


                                    <h3>Additional information about Data collection and processing</h3>
                                    <strong>Legal action</strong>
                                    <p>The User's Personal Data may be used for legal purposes by the Data Controller, in Court or in the stages leading to possible legal action arising from improper use of this Application or the related services.</p>

                                    <p>The User declares to be aware that the Data Controller may be required to reveal personal data upon request of public authorities.</p>

                                    <strong>Additional information about User's Personal Data</strong>
                                    <p>In addition to the information contained in this privacy policy, this Application may provide the User with additional and contextual information concerning particular services or the collection and processing of Personal Data upon request.</p>

                                    <strong>System logs and maintenance</strong>
                                    <p>For operation and maintenance purposes, this Application and any third party services may collect files that record interaction with this Application (System logs) or use for this purpose other Personal Data (such as IP Address).</p>

                                    <strong>Information not contained in this policy</strong>
                                    <p>More details concerning the collection or processing of Personal Data may be requested from the Data Controller at any time. Please see the contact information at the beginning of this document.</p>

                                    <strong>The rights of Users</strong>
                                    <p>Users have the right, at any time, to know whether their Personal Data has been stored and can consult the Data Controller to learn about their contents and origin, to verify their accuracy or to ask for them to be supplemented, cancelled, updated or corrected, or for their transformation into anonymous format or to block any data held in violation of the law, as well as to oppose their treatment for any and all legitimate reasons. Requests should be sent to the Data Controller at the contact information set out above.</p>

                                    <strong>This Application does not support “Do Not Track” requests.</strong>
                                    <p>To determine whether any of the third party services it uses honour the “Do Not Track” requests, please read their privacy policies.</p>

                                    <strong>Changes to this privacy policy</strong>
                                    <p>The Data Controller reserves the right to make changes to this privacy policy at any time by giving notice to its Users on this page. It is strongly recommended to check this page often, referring to the date of the last modification listed at the bottom. If a User objects to any of the changes to the Policy, the User must cease using this Application and can request that the Data Controller remove the Personal Data. Unless stated otherwise, the then-current privacy policy applies to all Personal Data the Data Controller has about Users.</p>

                                    <strong>Information about this privacy policy</strong>
                                    <p>The Data Controller is responsible for this privacy policy.</p>
                                </div>

                                <hr>

                                <div v-if="countryCodeSetting === 'GB'">
                                    <a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/uk/documents/Likewize_Repair_Privacy_Policy.pdf">Click to see our full privacy policy</a> <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/pdf_32x32.png" alt="Adobe">
<!--										<a target="_blank" href="https://wefix-files.s3.eu-west-2.amazonaws.com/documents/wefix-privacy-policy-23-12-18.pdf">Click to see our full privacy policy</a> <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/pdf_32x32.png" alt="Adobe">-->
                                </div>

                                <div v-if="countryCodeSetting === 'AU'">
                                    <a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/au/documents/Likewize_AU_Privacy_Policy.pdf">Click to see our full privacy policy</a> <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/pdf_32x32.png" alt="Adobe">
                                </div>
                            </div>
                        </div>
					</div>
				</div>
        <div class="row" v-else>
          <h1 class="w-100 mb-4">Datenschutzerklärung Likewize Europe GmbH</h1><br>
          <h2 class="w-100 mb-4">Datenschutzerklärung</h2>
          <h3 class="w-100 mb-4">Einleitung</h3>
          <p class="mb-0 w-100">Willkommen zu unserer Datenschutzerklärung. In diesem Dokument erläutern wir Ihnen in
            klarer und verständlicher Sprache, wie wir Ihre personenbezogenen Daten verwenden, welche Rechte Sie haben
            und was Sie von uns erwarten können.
            Wir bitten Sie nicht um Ihre Zustimmung zu dieser Erklärung; sie dient ausschließlich dazu, Sie darüber zu
            informieren, wie wir mit Ihren Daten umgehen.</p>
          <p class="w-100">Zur besseren Übersicht haben wir diese Datenschutzerklärung in verschiedene Abschnitte
            gegliedert. Wir überprüfen sie regelmäßig. Dies ist Version 1.0, zuletzt aktualisiert am 10. April 2026.</p>
          <h3 class="w-100 my-4">Wer wir sind</h3>
          <p>Wir sind Likewize Europe GmbH, Teil der Likewize-Unternehmensgruppe. Diese Datenschutzerklärung beschreibt
            die Verarbeitung Ihrer personenbezogenen Daten im Zusammenhang mit Ihrer aktuellen Transaktion mit uns.
            Weitere Informationen zu den Datenschutzpraktiken der Likewize-Gruppe finden Sie unter: <a
                href="https://www.likewize.com/privacy/">www.likewize.com/privacy/</a></p>
          <h3 class="w-100 my-4">Kontakt zum Datenschutzbeauftragten</h3>
          <p class="mb-0 w-100"><strong>E-Mail:</strong> privacy@likewize.com</p>
          <p class="mb-0 w-100"><strong>Postanschrift:</strong> Datenschutzbeauftragter</p>
          <p class="mb-0 w-100">Ratinger Str. 10</p>
          <p class="mb-0 w-100">42579 Heiligenhaus</p>
          <p class="mb-0 w-100">Deutschland</p>
          <h3 class="w-100 my-4">
            Personenbezogene Daten, die wir erheben oder verarbeiten
          </h3>
          <p>Wir erheben und verarbeiten personenbezogene Daten, die notwendig sind, um unsere Dienstleistungen zu
            erbringen. Einige Angaben sind nicht verpflichtend; wir informieren Sie, wenn Sie eine Wahl haben.</p>
          <h3 class="w-100 my-4">Zu den von uns erhobenen Daten gehören:</h3>
          <ul>
            <li>Name, Adresse (Liefer- und Rechnungsadressen)</li>
            <li>E-Mail-Adresse, Telefonnummern</li>
            <li>Finanzdaten wie Bankverbindungen, Kontonummern, Sort Codes, Zahlungskartendaten</li>
            <li>Geräteinformationen, IMEI-Nummern, Transaktionsdaten, erworbene Dienstleistungen</li>
            <li>Angaben aus Umfragen oder Website-Feedback</li>
            <li>Technische Daten über Ihre Nutzung unserer Website</li>
            <li>Kommunikations- und Marketingpräferenzen</li>
          </ul>
          <p class="mb-0 w-100">Wir erheben keine besonderen Kategorien personenbezogener Daten und keine Daten zu
            strafrechtlichen Verurteilungen über diese Website.</p>
          <p class="w-100">Bitte informieren Sie uns über Änderungen Ihrer Daten, damit diese aktuell bleiben.</p>
          <h3 class="w-100 my-4">Rechtsgrundlagen für die Verarbeitung Ihrer Daten</h3>
          <p>Wir verarbeiten Ihre Daten auf Basis folgender Rechtsgrundlagen:</p>
          <h3 class="w-100 my-4">Vertragserfüllung</h3>
          <p>Wir benötigen Ihre Kontaktdaten, Finanzinformationen und Gerätedaten, um unsere Dienstleistungen zu
            erbringen.</p>
          <h3 class="w-100 my-4">Gesetzliche Verpflichtung</h3>
          <p>Wir müssen bestimmte Daten speichern, insbesondere für Finanz- und Steuerzwecke.</p>
          <h3 class="w-100 my-4">Berechtigte Interessen</h3>
          <p>Wir verarbeiten Daten zur Pflege unserer Geschäftsbeziehung mit Samsung sowie zur Verbesserung unserer
            Website und Dienstleistungen.</p>
          <h3 class="w-100 my-4">Rechtliche Informationspflichten</h3>
          <p>Wir verwenden Ihre Kontaktdaten, um Ihnen gesetzlich vorgeschriebene Mitteilungen zu senden.</p>
          <h3 class="w-100 my-4">Weitergabe Ihrer Daten und internationale Datenübermittlungen</h3>
          <p>Wir geben Ihre Daten an folgende Empfänger weiter:</p>
          <h3 class="w-100 my-4">Unternehmen der Likewize-Gruppe</h3>
          <p>Wir nutzen interne Vereinbarungen und EU-Standardvertragsklauseln, wenn Daten in Länder außerhalb der EU
            übermittelt werden.</p>
          <h3 class="w-100 my-4">Dienstleister und externe Anbieter</h3>
          <p>Zahlungsdienstleister, IT-Anbieter, Logistikpartner, Berater, Auditoren. Auch hier stellen wir geeignete
            Schutzmaßnahmen sicher.</p>
          <h3 class="w-100 my-4">Behörden</h3>
          <p>Wenn wir gesetzlich verpflichtet sind, Daten weiterzugeben.</p>
          <p>Wir verkaufen Ihre Daten nicht.</p>
          <h3 class="w-100 my-4">Speicherdauer Ihrer Daten</h3>
          <p>Wir speichern Ihre Daten nur so lange wie notwendig.</p>
          <h3 class="w-100 my-4">Typische Aufbewahrungsfristen:</h3>
          <ul>
            <li>Finanztransaktionen: 6 Jahre plus laufendes Geschäftsjahr</li>
            <li>Umsatzsteuerrelevante Daten: 10 Jahre</li>
            <li>Angebote ohne Abschluss: bis zu 1 Jahr</li>
            <li>Längere Speicherung bei rechtlichen Gründen (z. B. Beschwerden)</li>
          </ul>
          <h3 class="w-100 my-4">Ihre Rechte</h3>
          <p>Sie können Ihre Rechte über die oben genannten Kontaktwege ausüben.</p>
          <h3 class="w-100 my-4">Recht auf Auskunft</h3>
          <p>Sie können eine Kopie Ihrer personenbezogenen Daten anfordern. Dies ist in der Regel kostenlos.</p>
          <h3 class="w-100 my-4">Recht auf Berichtigung</h3>
          <p>Sie können die Korrektur unrichtiger Daten verlangen. Bei Meinungsangaben können Sie eine ergänzende
            Erklärung hinzufügen lassen.</p>
          <h3 class="w-100 my-4">Recht auf Löschung</h3>
          <p>Sie können die Löschung nicht erforderlicher Daten verlangen. Gesetzliche Aufbewahrungspflichten können
            eine vollständige Löschung verhindern.</p>
          <h3 class="w-100 my-4">Widerspruchsrecht</h3>
          <p>Sie können der Direktwerbung jederzeit widersprechen. Bei Verarbeitung auf Basis berechtigter Interessen
            prüfen wir Ihren Widerspruch.</p>
          <h3 class="w-100 my-4">Recht auf Einschränkung der Verarbeitung</h3>
          <p>Sie können eine Einschränkung verlangen, wenn eine Klärung erforderlich ist.</p>
          <h3 class="w-100 my-4">Recht auf Datenübertragbarkeit</h3>
          <p>In bestimmten Fällen können Sie Ihre Daten in einem übertragbaren Format anfordern.</p>
          <h3 class="w-100 my-4">Recht auf Widerruf der Einwilligung</h3>
          <p>Wenn wir Daten auf Basis Ihrer Einwilligung verarbeiten, können Sie diese jederzeit widerrufen.</p>
          <h3 class="w-100 my-4">Beschwerderecht</h3>
          <p class="w-100">Sie können sich jederzeit an die zuständige Aufsichtsbehörde wenden:</p>
          <p class="mb-0 w-100">Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen</p>
          <p class="mb-0 w-100">Kavalleriestraße 2-4</p>
          <p class="mb-0 w-100">40213 Düsseldorf</p>
          <p class="mb-0 w-100">Telefon: (0211) 38424-0</p>
          <p class="mb-0 w-100">Fax: (0211) 38424-999</p>
          <p class="mb-0 w-100">E-Mail: <a href="mailto:poststelle@ldi.nrw.de">poststelle@ldi.nrw.de</a></p>
        </div>
			</div>
		</div>

		<!-- Footer -->
		<page-footer></page-footer>
	</div>
</template>

<script>
if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
	require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
	require('@/styles/core/whitelabel/wefix.scss');
}

import {mapGetters} from "vuex";

export default {
	name: "PrivacyIndex",

	computed: {
		...mapGetters([
			'carrierDetails',
            'countryCodeSetting'
		])
	}
}
</script>

<style scoped>

</style>